const DECISIONTYPES = {
  notNeeded: 'notNeeded',
  preApproved: 'preApproved',
  declined: 'declined',
  additionalDown: 'additionalDown',
  noInfo: 'noInfo',
};

export default DECISIONTYPES;
